export default __webpack_public_path__ + "static/media/tcl-masterImage.da3feac0.png";